import React, { StrictMode, lazy, Suspense } from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import reducer from './store/reducers/auth';
import ErrorBoundary from './views/pages/systemSupport/ErrorBoundary.jsx';
import { PulseDivLoader } from './components/Loading/LoadingOverlay.js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { initClarity } from './utils/clarity';
import { createStore, compose, applyMiddleware } from 'redux';
import './assets/css/nucleo-icons.css';
import './assets/css/animo-icons.css';
import "./assets/css/insight-icons.css";
import './assets/css/animo.css';
import './assets/css/section-washup.css';
import './assets/css/data-errors.css';
import './assets/scss/animo.scss';
import "./assets/scss/animo.scss?v=1.0.0";
// import 'react-notification-alert/dist/animate.css';
const composeEnhances = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducer, composeEnhances(
  applyMiddleware(thunk)
));
const hist = createBrowserHistory();

initClarity(process.env.REACT_APP_CLARITY_PROJECT_ID || 'YOUR_PROJECT_ID');

const AuthLayout = lazy(() => import('./layouts/Auth/Auth.jsx'));
const AdminLayout = lazy(() => import('./layouts/Admin/Admin.jsx'));
const PopOutLayout = lazy(() => import('./layouts/Popout/PopOut.jsx'));

const WebRoutes = () => {
  console.log('current request', window.location.href)
  return (
    <Routes>
      <Route path="/auth/*" element={<AuthLayout />} >
      </Route>
      <Route path="/admin/*" element={<AdminLayout />} >
      </Route>
      <Route path="/popOut/*" element={<PopOutLayout />} >
      </Route>
      <Route
        path="*"
        element={<Navigate replace to="/auth/login" />}
      />
      <Route
        path="/auth"
        element={<Navigate replace to="/auth/login" />}
      />
    </Routes >
  );
}
const loader = async () => {
  const user = await getUser();
  if (!user) {
    return redirect("/auth");
  }
  return null;
};

// Create QueryClient with optimized configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
      onError: (err) => {
        console.error("Mutation failed:", err);
      },
    },
  },
});
const App = () => (
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <Router navigator={hist} history={hist}>
        <Suspense fallback={<PulseDivLoader />}>
          <ErrorBoundary>
            <WebRoutes />
          </ErrorBoundary>
        </Suspense>
      </Router>
    </Provider>
    {/* Only show dev tools in development */}
    {/* {process.env.NODE_ENV === 'development' && (
      <ReactQueryDevtools initialIsOpen={false} />
    )} */}
  </QueryClientProvider>
);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />
)
